'use client';

import type { ReactNode } from 'react';
import { Dialog } from 'radix-ui';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

// The overlay, centred panel and titled header with a close button that Wolven's dialogs share.
// Render it inside a `Dialog.Root`, which owns whether it is open.
export function DialogSurface({ title, children }: { title: ReactNode; children: ReactNode }) {
  return (
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-[300] bg-background/60 backdrop-blur-[2px] data-open:animate-in data-open:fade-in-0 motion-reduce:animate-none" />
      <Dialog.Content className="fixed top-1/2 left-1/2 z-[300] flex max-h-[90dvh] w-[calc(100vw-2rem)] max-w-md -translate-1/2 flex-col gap-4 overflow-y-auto rounded-lg border bg-popover p-6 text-popover-foreground shadow-popover outline-none data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 motion-reduce:animate-none">
        <div className="flex items-start justify-between gap-4">
          <Dialog.Title className="text-lg">{title}</Dialog.Title>
          <Dialog.Close asChild>
            <Button variant="ghost" size="icon-sm" aria-label="Close" className="-mt-1 -mr-2">
              <X />
            </Button>
          </Dialog.Close>
        </div>
        {children}
      </Dialog.Content>
    </Dialog.Portal>
  );
}
